/**
* DevExpress Dashboard (_range-info.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { itemType } from '../../../../metadata/_base-metadata';
import { ComplexValue } from '../../../format-rules-common';
export let rangeValue = { propertyName: 'value', modelName: 'Value', displayName: 'DashboardStringId.CommandFormatRuleValue', type: ComplexValue };
export let rangeValueComparison = {
    propertyName: 'valueComparison', modelName: '@ValueComparison', displayName: 'DashboardWebStringId.ConditionalFormatting.ValueComparison', defaultVal: 'GreaterOrEqual', simpleFormAdapterItem: 'selectBoxEditor', values: {
        'Greater': '>',
        'GreaterOrEqual': '≥'
    }
};
export let rangeInfoSerializationsInfo = [itemType, rangeValue, rangeValueComparison];
